import { ReactNode } from "react";
import { StyledDrawer, StyledDrawerContainer } from "./drawer.styles";

type DrawerProps = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  title: string;
  subtitle?: string;
};

export const Drawer = ({
  open,
  onClose,
  children,
  subtitle,
  title,
}: DrawerProps) => {
  return (
    <StyledDrawer
      title={title}
      open={open}
      onClose={onClose}
      subtitle={subtitle}
    >
      <StyledDrawerContainer>{children}</StyledDrawerContainer>
    </StyledDrawer>
  );
};
